module.exports = __webpack_public_path__ + "img/instagram.aa9c3be6.gif";